export const SET_SIGNUP_INFO_REQUEST = 'SET_SIGNUP_INFO_REQUEST'
export const SET_SIGNUP_INFO_SUCCESS = 'SET_SIGNUP_INFO_SUCCESS';
export const SET_SIGNUP_INFO_FAIL = 'SET_SIGNUP_INFO_FAIL'